var render = function render(){var _vm=this,_c=_vm._self._c;return _c('no-ssr',[_c('VueSlider',_vm._b({ref:"slider",attrs:{"value":_vm.propValue},on:{"callback":function($event){return _vm.emitInput($event)},"drag-end":function($event){return _vm.$emit('drag-end')}}},'VueSlider',_vm.options,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }